type TCachedDebounceOptions = {
    wait?: number
    mounted?: boolean
}

type TDebounceCache<T> = {
    data: T[]
    debounce: (() => void) | null
}

interface IDebounceCacheData {
    id: number
}

export function debounce(fn: (...args: any[]) => void, wait = 1) {
    let timeout: number
    return function (...args: any[]) {
        clearTimeout(timeout)
        timeout = window.setTimeout(() => fn.call(null, ...args), wait)
    }
}

export function createCachedDebounce<T extends IDebounceCacheData>(
    data: T | T[],
    cache: TDebounceCache<T>,
    cb: (data: T[]) => void,
    options: TCachedDebounceOptions = {}
) {
    const { wait = 800, mounted = true } = options

    if (Array.isArray(data)) {
        data.forEach((item) => {
            const existingElementIndex = cache.data.findIndex((existElement) => existElement.id === item.id)

            if (existingElementIndex !== -1) {
                cache.data[existingElementIndex] = item
            } else {
                cache.data.push(item)
            }
        })
    } else {
        const existingElementIndex = cache.data.findIndex((existElement) => existElement.id === data.id)

        if (existingElementIndex !== -1) {
            cache.data[existingElementIndex] = data
        } else {
            cache.data.push(data)
        }
    }

    const constructDebounce = debounce(() => {
        if (!mounted) {
            return
        }

        cb([...cache.data])
        cache.data = []
        cache.debounce = null
    }, wait)

    if (!cache.debounce) {
        cache.debounce = constructDebounce
        cache.debounce()
    }
}
